import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
  QueryList,
  ContentChildren,
  AfterContentInit
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { PayloadAction } from '@ipreo/muni-shared';
import { TabComponent } from '../tab/tab.component';

export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';

@Component({
  selector: 'muni-gameday-tabbed-panel',
  templateUrl: './tabbed-panel.template.html',
  styleUrls: ['../../panel/panel.styles.scss', './tabbed-panel.styles.scss']
})
export class TabbedPanelComponent
  implements AfterViewInit, OnDestroy, AfterContentInit {
  @Input()
  public linkText: string;
  @Input()
  public activeTab: Observable<number>;
  @Input()
  public subscribeOnChange: boolean;
  @Input()
  public reactOnChange: boolean;
  @Input()
  public linkUrl: string;
  @Input()
  public linkParams: any;
  @Input()
  public condensed = false;
  @Output()
  public readonly changed: EventEmitter<PayloadAction<any>> = new EventEmitter<
    PayloadAction<any>
  >();
  @Output()
  public readonly linkClick: EventEmitter<Event> = new EventEmitter<Event>();
  @ContentChildren(TabComponent)
  public tabs: QueryList<TabComponent>;

  private activeTabSubscription: Subscription;

  public ngAfterViewInit(): void {
    if (this.subscribeOnChange) {
      this.activeTabSubscription = this.activeTab
        .pipe(distinctUntilChanged())
        .subscribe((index) => {
          const tab = this.tabs.toArray()[index];
          if (tab) {
            this.selectTab(tab, false);
          }
        });
    }
  }

  public ngAfterContentInit(): void {
    if (!this.tabs.some((tab) => tab.active)) {
      this.selectTab(this.tabs.first);
    }
  }

  public ngOnDestroy(): void {
    if (this.activeTabSubscription) {
      this.activeTabSubscription.unsubscribe();
    }
  }

  public selectTab(clickedTab: TabComponent, emitEvent?: boolean): void {
    if (!clickedTab || clickedTab.active || clickedTab.disabled) {
      return;
    }

    let index = -1;

    this.tabs.forEach((tab, i) => {
      tab.active = false;
      if (tab === clickedTab) {
        index = i;
      }
    });

    if (index === -1) {
      throw new Error('The tab does not belong to TabbedPanelComponent');
    }

    if (this.reactOnChange && emitEvent) {
      this.changed.emit({ type: SET_ACTIVE_TAB, payload: index });
    }

    if (!this.subscribeOnChange || !emitEvent) {
      clickedTab.active = true;
    }
  }
}
